import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { serviceDetails } from '../data/serviceDetails';

function IndustrialRepair() {
  return <ServiceDetailPage service={serviceDetails.industrialRepair} />;
}

export default IndustrialRepair;
